import { Dispatch } from 'redux';
import { RESET_ATR } from './types';

function clearAtr() {
  return function action(dispatch: Dispatch) {
    dispatch({
      type: RESET_ATR,
    });
  };
}

export default clearAtr;
